module.exports = __webpack_public_path__ + "img/37games-logo.03d8e92a.png";